import { useTranslation } from 'react-i18next';
import { MyProfileTemplate } from '@ideoz/ui';
import { useMyProfile } from './useMyProfile';

/**
 * User-account profile module: renders the shared MyProfileTemplate wired to
 * the web logout / auth / startup-sidebar logic in {@link useMyProfile}.
 * Appearance + Language now live on the dedicated App Settings page.
 */
export function MyProfileModule(): JSX.Element {
  const { t } = useTranslation();
  const { user, authDialog, facade } = useMyProfile();

  if (!user) {
    return <div>{t('common.loading')}</div>;
  }

  return <MyProfileTemplate facade={facade} isWeb authDialogState={authDialog} />;
}
